import { useState } from 'react';
import { SecurityType } from '@dealstack/shared/lib/generated';
import { HoldingVestingDetail } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetails/components/HoldingTable/HoldingVestingDetail.tsx';
import {
	HoldingsCardsStyles,
	HoldingVestingCardStyles,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/HoldingsCards.styles.tsx';
import { HoldingCardItem } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/HoldingCardItem.tsx';
import { InvestorHoldingRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/investorHoldings.types.ts';

interface Props {
	rows: InvestorHoldingRow[];
	getSecurityTypeTranslation: (type: SecurityType) => string;
	heldColumn?: 'via' | 'for';
}

export const HoldingsCards = ({ rows, getSecurityTypeTranslation, heldColumn }: Props) => {
	const [expandedId, setExpandedId] = useState<string | null>(null);

	const expanded = rows.find((holding) => holding.id === expandedId);

	return (
		<>
			<HoldingsCardsStyles>
				{rows.map((holding) => (
					<HoldingCardItem
						key={holding.id}
						holding={holding}
						securityTypeLabel={getSecurityTypeTranslation(holding.securityType)}
						heldColumn={heldColumn}
						isExpanded={holding.id === expandedId}
						onToggleVesting={() =>
							setExpandedId((current) => (current === holding.id ? null : holding.id))
						}
					/>
				))}
			</HoldingsCardsStyles>

			{!!expanded?.heldForInvestorId && (
				<HoldingVestingCardStyles>
					<HoldingVestingDetail
						investorId={expanded.heldForInvestorId}
						securityId={expanded.securityId}
					/>
				</HoldingVestingCardStyles>
			)}
		</>
	);
};
